import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * QuizStart component
 */
export default class QuizStart extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuizStart',
    refs: ['btn', 'modal', 'progress', 'display', 'pause'],
    options: {
      href: {
        type: String,
      },
    },
  };

  isPause = false;

  /**
   *
   */
  onBtnClick() {
    removeClass(this.$refs.modal, ['opacity-0', 'pointer-events-none']);
    addClass(this.$refs.modal, ['active']);
    this.remainingTime = 5;
    this.updateTimer();
    this.timerInterval = setInterval(this.updateTimer.bind(this), 1000);
  }

  /**
   *
   */
  updateTimer() {
    // Calculate minutes and seconds
    const seconds = this.remainingTime % 60;

    // Display the time in "m:ss" format
    this.$refs.display.textContent = `${seconds.toString().padStart(2, '0')}`;

    // Check if timer has reached zero
    if (this.remainingTime > 0) {
      this.remainingTime -= 1;
    } else {
      clearInterval(this.timerInterval);
      window.location.href = this.$options.href;
    }
  }

  /**
   * Pause the timer
   */
  onPauseClick() {
    if (!this.isPause) {
      clearInterval(this.timerInterval);
      addClass(this.$refs.modal, ['pause']);
    } else {
      removeClass(this.$refs.modal, ['pause']);
      this.updateTimer();
    }
    this.isPause = !this.isPause;
  }

  /**
   * Resume the timer
   */
  resumeTimer() {
    if (!this.timerInterval) {
      this.updateTimer();
    }
  }
}
